// extracted by mini-css-extract-plugin
module.exports =  {"form":"_32bbee5fda--form--bKSGu","field--main":"_32bbee5fda--field--main--X9EBt","license":"_32bbee5fda--license--Ni6Vt","message--succeed":"_32bbee5fda--message--succeed--RzvnI"};